import { FunctionalComponent, h } from "preact";
import { useEffect, useState } from "preact/hooks";
import { useAppSelector } from "../../redux/hooks";
import KorraVideoPlayer from "../../components/korraVideoPlayer";
import desktop from "./desktop.css";
import { memo } from "preact/compat";
import { isMobileOnly as isMobileOnlyReact } from "react-device-detect";
interface Props {
  workspaceId: string;
  kappId: string;
  portalId?: string;
  workspaceAlias?: string;
  portalAlias?: string;
  docGuid: string;
  guid: string;
  chatbotFlag?: string;
  videoContainerRef?: any;
  handleToggleFullScreen?: () => void;
  setDrawerOpen?: (value: boolean) => void;
  isDrawerOpen?: boolean;
}

const ChatbotVideo: FunctionalComponent<Props> = (props: Props) => {
  const {
    workspaceId,
    kappId,
    portalId,
    workspaceAlias,
    portalAlias,
    docGuid,
    guid,
    chatbotFlag,
    videoContainerRef,
    handleToggleFullScreen,
    setDrawerOpen,
    isDrawerOpen,
  } = props;

  // const [title, setTitle] = useState<string>("Korra Video Player");
  const alias = useAppSelector((state) => state.alias);
  const globals = useAppSelector((state) => state.globals);
  // (window as any).addEventListener("korra-file-name", (r: any) => {
  //   if (r?.detail) setTitle(r?.detail);
  // });
  useEffect(() => {
    if (isDrawerOpen) document.title = "Korra Video Player";
  }, [isDrawerOpen]);

  return (
    <div
      className={desktop.Chatbotcontainer}
      ref={videoContainerRef}
      style={{
        top: chatbotFlag ? "0px" : "",
        height: "96%",
        width: "100%",
      }}
    >
      {isDrawerOpen && (
        <KorraVideoPlayer
          workspaceid={workspaceId || alias.workspaceId}
          portalid={portalId || alias.portalId}
          kappid={kappId}
          workspaceAlias={workspaceAlias}
          portalAlias={portalAlias}
          guid={guid}
          docguid={docGuid}
          muted={false}
          autoplay={true}
          controls={true}
          jwtUserIdToken={globals.jwtUserIdToken || undefined}
          userId={globals.userId || undefined}
          handleToggleFullScreen={handleToggleFullScreen}
          isMobile={isMobileOnlyReact}
        />
      )}
    </div>
  );
};

export default memo(ChatbotVideo);
